import { Play, Clock } from "lucide-react";
import { toast } from "sonner";
import { FadeIn, Eyebrow } from "./primitives";

const CURTAIN_IMAGE =
  "https://images.unsplash.com/photo-1705944601101-fdb49dbf884c?auto=format&fit=crop&w=1200&q=80";

export const LatestEpisode = ({ episode }) => {
  if (!episode) return null;

  const handlePlay = () => {
    toast.info("Streaming links go live at launch — follow the show to be first to hear it.");
  };

  return (
    <section id="latest" data-testid="latest-episode-section" className="mx-auto max-w-6xl px-6 py-24">
      <FadeIn>
        <Eyebrow>Latest episode</Eyebrow>
      </FadeIn>

      <FadeIn delay={0.1} className="mt-10">
        <div className="grid overflow-hidden border border-bone/10 bg-coal md:grid-cols-2">
          <div className="relative min-h-[280px]">
            <img
              src={CURTAIN_IMAGE}
              alt="Deep red cinema curtain"
              className="absolute inset-0 h-full w-full object-cover opacity-80"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-transparent to-coal/60 md:bg-gradient-to-r" />
          </div>

          <div className="flex flex-col justify-center p-10 md:p-14">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-smoke">
              Episode {String(episode.number).padStart(2, "0")} · {episode.film}
            </p>
            <h2
              data-testid="latest-episode-title"
              className="mt-4 font-display text-3xl font-light leading-tight tracking-tight text-bone sm:text-4xl"
            >
              {episode.title}
            </h2>
            {episode.note && (
              <p className="mt-6 max-w-md text-base font-light leading-relaxed text-zinc-400">
                {episode.note}
              </p>
            )}
            <div className="mt-10 flex flex-wrap items-center gap-6">
              {episode.watch_url ? (
                <a
                  href={episode.watch_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="latest-play-button"
                  className="flex items-center gap-3 bg-ruby px-7 py-3.5 font-mono text-xs uppercase tracking-[0.2em] text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-ruby-bright"
                >
                  <Play size={14} /> Watch the episode
                </a>
              ) : (
                <button
                  onClick={handlePlay}
                  data-testid="latest-play-button"
                  className="flex items-center gap-3 bg-ruby px-7 py-3.5 font-mono text-xs uppercase tracking-[0.2em] text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-ruby-bright"
                >
                  <Play size={14} /> Play episode
                </button>
              )}
              <span className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-smoke">
                <Clock size={13} /> {episode.duration}
              </span>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>
  );
};
